export default __webpack_public_path__ + "static/media/green-tick.5ffe6338.svg";